// IMPORTANT: Make sure this is in sync with functions/src/index.ts
export enum STRIPE_PAYMENT_INTENT_UPDATE_MODE_TYPE {
    lightweight = 'lightweight',
    final = 'final',
}
